'use client'

import { useLayoutEffect, useState } from 'react'

import { ErrorPage, MobileErrorPage } from '@/pages/error'
import { isMobileUserAgent } from '@/shared/lib'

export default function Error() {
  const [isMobile, setIsMobile] = useState(true)

  useLayoutEffect(() => {
    setIsMobile(isMobileUserAgent(navigator.userAgent))
  }, [])

  return isMobile ? <MobileErrorPage /> : <ErrorPage />
}
